import { parseDocumentMeta } from '../../../helpers/parseDocumentMeta'
import { IAplDocument } from '../../../models/aplDocument'

export const getUploadHistory = (aplDocuments: IAplDocument[]) => {
  return Object.entries(
    aplDocuments.reduce(
      (acc, it) => {
        const meta = parseDocumentMeta(it.Meta)
        if (!meta) {
          return acc
        }

        const documentsHistory = acc[meta.date] || []

        return {
          ...acc,
          [meta.date]: [...documentsHistory, it],
        }
      },
      {} as Record<string, IAplDocument[]>
    )
  )
}
